import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const playgroundBannerSchema = {
    componentId: "PlaygroundBanner",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Subheading",
            type: "textarea",
        },
        { key: "variant", label: "Layout (centered / split)", type: "text" },
    ],
    mediaSlots: [
        {
            key: "media",
            label: "Banner media",
            // DECLARATION ORDER LOAD-BEARING — desktop first. The acceptance drivers
            // compare declared vs example targets in order, and the stored ref
            // carries targets[0]'s cropId. Reordering these silently retargets what
            // a seeded slot's reference names.
            targets: [
                { width: 1920, height: 1080, aspectRatio: "16:9" },
                { width: 1080, height: 1920, aspectRatio: "9:16" },
            ],
        },
    ],
    layout: {
        key: "variant",
        fallback: "centered",
        // The fallback hides media on purpose: the default layout is the trap —
        // an Editor who never touches the layout can hold a photo nobody sees,
        // which is filled-slot-never-silently-dropped's central claim. And
        // `centered: []` is written out deliberately: a real layout that displays
        // no media, not an omission or an unrecognised value.
        displaysMediaSlots: { centered: [], split: ["media"] },
    },
};
//# sourceMappingURL=playground-banner.js.map